import React, { useEffect, useMemo, useState } from "react";
import { auth, db } from "../firebase";
import {
  addDoc,
  collection,
  getDocs,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import "./AdminAddIceHockey.css";

const COLLECTION = "icehockeymatches";
const TIMEZONE = "Africa/Dar_es_Salaam";

// Inakubali Firebase Auth au login ya app inayohifadhi taarifa kwenye localStorage.
// Kumbuka: Firestore Rules bado zinaweza kuhitaji Firebase Authentication halisi.
function getAdminIdentity() {
  if (auth.currentUser) {
    return { uid: auth.currentUser.uid };
  }

  try {
    const authenticated = localStorage.getItem("authenticated");
    const role = (localStorage.getItem("role") || "").toLowerCase();
    const username =
      localStorage.getItem("username") ||
      localStorage.getItem("user") ||
      "local-admin";

    if (authenticated === "true" && role === "admin") {
      return { uid: username };
    }
  } catch (error) {
    // localStorage inaweza kutopatikana kwenye mazingira fulani.
  }

  return null;
}


const EMPTY_FORM = {
  country: "",
  league: "",
  homeTeam: "",
  awayTeam: "",
  date: "",
  time: "",
  homeOdds: "2.00",
  drawOdds: "3.75",
  awayOdds: "3.00",
};
const DEFAULT_SCORE_ODDS = [
  { score: "0-0", odds: 0.5 },
  { score: "1-0", odds: 2.5 },
  { score: "0-1", odds: 1.0 },
  { score: "1-1", odds: 3.5 },
  { score: "2-0", odds: 1.5 },
  { score: "0-2", odds: 2.0 },
  { score: "2-1", odds: 2.0 },
  { score: "1-2", odds: 4.0 },
  { score: "2-2", odds: 1.0 },
  { score: "3-0", odds: 2.5 },
  { score: "0-3", odds: 5.5 },
  { score: "3-1", odds: 1.5 },
  { score: "1-3", odds: 3.5 },
  { score: "3-2", odds: 4.0 },
  { score: "2-3", odds: 4.0 },
  { score: "3-3", odds: 1.0 },
  { score: "4-1", odds: 3.0 },
  { score: "1-4", odds: 2.5 },
  { score: "4-2", odds: 4.5 },
  { score: "2-4", odds: 1.5 },
  { score: "4-3", odds: 3.5 },
  { score: "3-4", odds: 2.0 },
  { score: "4-4", odds: 5.0 },
];


function toNumber(value) {
  if (value === "" || value == null) return null;
  const n = Number(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function validDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ""))) {
    return false;
  }

  const date = new Date(`${value}T12:00:00Z`);
  return (
    !Number.isNaN(date.getTime()) &&
    date.toISOString().slice(0, 10) === value
  );
}

function eatDate(offset = 0) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());

  const year = Number(parts.find((p) => p.type === "year").value);
  const month = Number(parts.find((p) => p.type === "month").value);
  const day = Number(parts.find((p) => p.type === "day").value);

  return new Date(
    Date.UTC(year, month - 1, day + offset, 12)
  ).toISOString().slice(0, 10);
}

function parseDateTime(value) {
  const text = String(value || "")
    .replace(/\u00a0/g, " ")
    .replace(/#\s*\d+\s*$/, "")
    .trim();

  let match = text.match(
    /^(Today|Tomorrow)\s+(\d{1,2}):(\d{2})$/i
  );

  if (match) {
    const date = /^today$/i.test(match[1])
      ? eatDate(0)
      : eatDate(1);

    const hour = Number(match[2]);
    const minute = Number(match[3]);

    if (hour > 23 || minute > 59) return null;

    return {
      date,
      time: `${String(hour).padStart(2, "0")}:${String(
        minute
      ).padStart(2, "0")}`,
    };
  }

  match = text.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})\s+(\d{1,2}):(\d{2})$/ 
  );

  if (match) {
    const day = Number(match[1]);
    const month = Number(match[2]);
    let year = Number(match[3]);
    if (year < 100) year += 2000;

    const date = `${year}-${String(month).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;

    const hour = Number(match[4]);
    const minute = Number(match[5]);

    if (
      !validDate(date) ||
      hour > 23 ||
      minute > 59
    ) {
      return null;
    }

    return {
      date,
      time: `${String(hour).padStart(2, "0")}:${String(
        minute
      ).padStart(2, "0")}`,
    };
  }

  match = text.match(
    /^(\d{4}-\d{2}-\d{2})\s+(\d{1,2}):(\d{2})$/
  );

  if (match) {
    const date = match[1];
    const hour = Number(match[2]);
    const minute = Number(match[3]);

    if (
      !validDate(date) ||
      hour > 23 ||
      minute > 59
    ) {
      return null;
    }

    return {
      date,
      time: `${String(hour).padStart(2, "0")}:${String(
        minute
      ).padStart(2, "0")}`,
    };
  }

  return null;
}

function parseLeague(line) {
  const clean = cleanLine(line)
    .replace(/^\|+|\|+$/g, "")
    .trim();
  const hyphenParts = clean.split(/\s+-\s+/);

  if (hyphenParts.length >= 2) {
    return {
      country: hyphenParts[0].trim(),
      league: hyphenParts.slice(1).join(" - ").trim(),
    };
  }

  // Bookmaker headings can look like "Austria, ICE Hockey League".
  const commaParts = clean.split(/\s*,\s*/);
  if (commaParts.length >= 2) {
    return {
      country: commaParts[0].trim(),
      league: commaParts.slice(1).join(", ").trim(),
    };
  }

  return { country: "Other", league: clean || "Unknown League" };
}

function cleanLine(value) {
  return String(value || "")
    .replace(/\u00a0/g, " ")
    .replace(/\*\*/g, "")
    .replace(/<\/?strong>/gi, "")
    .replace(/<\/?b>/gi, "")
    .replace(/^\s*\|\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?\s*$/, "")
    .trim();
}

function extractOdds(line) {
  const values = String(line || "").match(/\d+\.\d{2}/g) || [];
  if (values.length !== 3) return null;
  const odds = values.map(Number);
  if (odds.some((value) => !Number.isFinite(value) || value < 1.01)) {
    return null;
  }
  return { home: odds[0], draw: odds[1], away: odds[2] };
}

function parseIceHockeyText(rawText) {
  const lines = String(rawText || "")
    .replace(/\r/g, "")
    .replace(/\u00a0/g, " ")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  const matches = [];
  let country = "Other";
  let league = "Unknown League";
  let pending = null;
  let plainTeams = [];

  const commit = (dateTime) => {
    if (!pending) return;
    const date = dateTime?.date || pending.date || "";
    const time = dateTime?.time || pending.time || "";
    if (pending.homeTeam && pending.awayTeam && validDate(date) && time) {
      matches.push({ ...pending, country, league, date, time });
    }
    pending = null;
    plainTeams = [];
  };

  const teamName = (value) => cleanLine(value)
    .replace(/^\|+|\|+$/g, "")
    .replace(/^\*+|\*+$/g, "")
    .trim();

  const oddsFromLine = (value) => {
    // Accept compact bookmaker odds such as 1.634.103.70 as well as spaced values.
    const cleaned = String(value || "").replace(/\s+/g, " ").trim();
    const compact = cleaned.match(/(?<!\d)(\d\.\d{2})(\d\.\d{2})(\d\.\d{2})(?!\d)/);
    if (compact) {
      const odds = compact.slice(1, 4).map(Number);
      if (odds.every((n) => Number.isFinite(n) && n >= 1.01)) {
        return { home: odds[0], draw: odds[1], away: odds[2] };
      }
    }
    return extractOdds(cleaned);
  };

  for (const rawLine of lines) {
    const line = cleanLine(rawLine);
    if (!line || /^\|?\s*:?-{2,}/.test(line) && line.includes("|")) continue;

    const cells = line.includes("|")
      ? line.replace(/^\|/, "").replace(/\|$/, "").split("|").map(teamName)
      : [];

    // League heading: use the first cell, ignoring the market columns.
    if (cells.length >= 2 && /^(1x2|underover|overunder)$/i.test(cells[1] || "")) {
      commit();
      const parsed = parseLeague(cells[0]);
      country = parsed.country;
      league = parsed.league;
      plainTeams = [];
      continue;
    }

    // The date/time row usually follows the corresponding teams/odds row.
    const dateCell = cells.length ? cells[0] : line;
    const dateTime = parseDateTime(dateCell);
    if (dateTime) {
      commit(dateTime);
      continue;
    }

    // Table row with both teams and 1X2 odds in a single row.
    if (cells.length >= 3) {
      const odds = cells.map(oddsFromLine).find(Boolean) || oddsFromLine(line);
      if (odds) {
        const names = cells.filter((cell) => {
          if (!cell || oddsFromLine(cell) || parseDateTime(cell)) return false;
          if (/^(1x2|underover|overunder|home|draw|away|odds)$/i.test(cell)) return false;
          if (/^[+-]\s*\d+(?:\.\d+)?$/.test(cell) || /^\d+$/.test(cell)) return false;
          return true;
        });
        if (names.length >= 2) {
          commit();
          pending = {
            country, league,
            homeTeam: names[0], awayTeam: names[1],
            date: "", time: "",
            homeOdds: odds.home, drawOdds: odds.draw, awayOdds: odds.away,
          };
          plainTeams = [];
        }
      }
      continue;
    }

    // Ignore totals/handicap and two-way Under/Over prices.
    if (/^[+-]\s*\d+(?:\.\d+)?$/.test(line)) continue;
    if (/^\d+\.\d{2}\s+\d+\.\d{2}$/.test(line)) continue;
    if (/^(1x2|underover|overunder|home|draw|away|odds|country|league)$/i.test(line)) continue;

    // Plain-text bookmaker layout: team, team, 1X2 odds, then date/time.
    const odds = oddsFromLine(line);
    if (odds && plainTeams.length >= 2) {
      commit();
      pending = {
        country, league,
        homeTeam: plainTeams[plainTeams.length - 2],
        awayTeam: plainTeams[plainTeams.length - 1],
        date: "", time: "",
        homeOdds: odds.home, drawOdds: odds.draw, awayOdds: odds.away,
      };
      plainTeams = [];
      continue;
    }
    if (line.includes("|") || /^https?:\/\//i.test(line)) continue;
    if (!pending && !/^\d/.test(line) && !/^\+/.test(line)) {
      plainTeams.push(teamName(line));
      if (plainTeams.length > 2) plainTeams = plainTeams.slice(-2);
    }
  }

  commit();
  return matches;
}

function makeScoreOdds(existing = []) {
  const previous = new Map(
    (Array.isArray(existing) ? existing : []).map((item) => [
      item.score,
      item.odds,
    ])
  );

  return DEFAULT_SCORE_ODDS.map((item) => ({
    score: item.score,
    odds: previous.get(item.score) ?? item.odds,
  }));
}

export default function AdminAddIceHockey() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [bulkText, setBulkText] = useState("");
  const [matches, setMatches] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [scoreHome, setScoreHome] = useState("");
  const [scoreAway, setScoreAway] = useState("");
  const [scoreOdds, setScoreOdds] = useState(() => makeScoreOdds());
  const [scoreSearch, setScoreSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [bulkSaving, setBulkSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const preview = useMemo(
    () => parseIceHockeyText(bulkText),
    [bulkText]
  );

  const filteredMatches = useMemo(() => {
    const query = search.trim().toLowerCase();

    return matches.filter((match) =>
      [
        match.country,
        match.league,
        match.homeTeam,
        match.awayTeam,
      ]
        .join(" ")
        .toLowerCase()
        .includes(query)
    );
  }, [matches, search]);

  const filteredScoreOdds = useMemo(() => {
    const query = scoreSearch.trim();
    return query
      ? scoreOdds.filter((item) => item.score.includes(query))
      : scoreOdds;
  }, [scoreOdds, scoreSearch]);

  async function loadMatches() {
    setLoading(true);
    setError("");

    try {
      const snapshot = await getDocs(collection(db, COLLECTION));
      const data = snapshot.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));

      data.sort((a, b) =>
        `${a.date || ""} ${a.time || ""}`.localeCompare(
          `${b.date || ""} ${b.time || ""}`
        )
      );

      setMatches(data);
    } catch (err) {
      setError(err?.message || "Imeshindikana kupakia mechi.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadMatches();
  }, []);

  function handleFormChange(event) {
    setForm((previous) => ({
      ...previous,
      [event.target.name]: event.target.value,
    }));
  }

  function validateMatch(match) {
    if (
      !match.country?.trim() ||
      !match.league?.trim() ||
      !match.homeTeam?.trim() ||
      !match.awayTeam?.trim()
    ) {
      return "Jaza nchi, ligi na majina ya timu.";
    }

    if (
      match.homeTeam.trim().toLowerCase() ===
      match.awayTeam.trim().toLowerCase()
    ) {
      return "Timu za mechi haziwezi kuwa sawa.";
    }

    if (!validDate(match.date) || !match.time) {
      return "Tarehe au muda si sahihi.";
    }

    for (const key of ["homeOdds", "drawOdds", "awayOdds"]) {
      const odds = toNumber(match[key]);
      if (odds == null || odds < 1.01) {
        return "Weka odds halali za Home, Draw na Away.";
      }
    }

    return "";
  }

  function makeMatchDocument(match) {
    return {
      sport: "icehockey",
      country: match.country.trim(),
      league: match.league.trim(),
      homeTeam: match.homeTeam.trim(),
      awayTeam: match.awayTeam.trim(),
      A: match.homeTeam.trim(),
      B: match.awayTeam.trim(),
      date: match.date,
      time: match.time,
      timezone: TIMEZONE,
      odds: {
        home: toNumber(match.homeOdds),
        draw: toNumber(match.drawOdds),
        away: toNumber(match.awayOdds),
      },
      correctScoreOdds: makeScoreOdds(),
      score: {
        home: null,
        away: null,
      },
      status: "upcoming",
      source: "admin",
      createdBy: getAdminIdentity().uid,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };
  }

  async function addMatch(event) {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (!getAdminIdentity()) {
      setError("Tafadhali login kama admin kwanza.");
      return;
    }

    const message = validateMatch(form);

    if (message) {
      setError(message);
      return;
    }

    setSaving(true);

    try {
      await addDoc(
        collection(db, COLLECTION),
        makeMatchDocument(form)
      );

      setForm(EMPTY_FORM);
      setSuccess("Mechi ya Ice Hockey imehifadhiwa.");
      await loadMatches();
    } catch (err) {
      setError(err?.message || "Imeshindikana kuhifadhi mechi.");
    } finally {
      setSaving(false);
    }
  }

  async function importBulk(event) {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (!getAdminIdentity()) {
      setError("Tafadhali login kama admin kwanza.");
      return;
    }

    if (!preview.length) {
      setError(
        "Hakuna mechi zilizotambuliwa. Hakikisha kila mechi ina timu mbili, odds tatu na tarehe/muda."
      );
      return;
    }

    const invalid = preview.find((match) => validateMatch(match));

    if (invalid) {
      setError(
        `Mechi ${invalid.homeTeam} dhidi ya ${invalid.awayTeam} ina taarifa zinazokosekana. Hakikisha tarehe na muda vipo.`
      );
      return;
    }

    setBulkSaving(true);
    let saved = 0;

    try {
      for (const match of preview) {
        await addDoc(
          collection(db, COLLECTION),
          {
            ...makeMatchDocument(match),
            source: "admin-bulk-import",
          }
        );
        saved += 1;
      }

      setBulkText("");
      setSuccess(`Mechi ${saved} zimeingizwa kikamilifu.`);
      await loadMatches();
    } catch (err) {
      setError(
        `${saved} zimehifadhiwa kabla ya hitilafu: ${err?.message || ""}`
      );
      await loadMatches();
    } finally {
      setBulkSaving(false);
    }
  }

  function selectMatch(match) {
    setSelectedId(match.id);
    setScoreHome(match.score?.home ?? "");
    setScoreAway(match.score?.away ?? "");
    setScoreOdds(makeScoreOdds(match.correctScoreOdds || []));
    setScoreSearch("");
    setError("");
    setSuccess("");

    document.getElementById("ih-results-editor")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  function changeScoreOdd(scoreName, value) {
    setScoreOdds((previous) =>
      previous.map((item) =>
        item.score === scoreName
          ? { ...item, odds: value }
          : item
      )
    );
  }

  async function saveResults() {
    setError("");
    setSuccess("");

    if (!getAdminIdentity()) {
      setError("Tafadhali login kama admin kwanza.");
      return;
    }

    if (!selectedId) {
      setError("Chagua mechi kwanza.");
      return;
    }

    const home = toNumber(scoreHome);
    const away = toNumber(scoreAway);

    if (
      home == null ||
      away == null ||
      !Number.isInteger(home) ||
      !Number.isInteger(away) ||
      home < 0 ||
      away < 0
    ) {
      setError("Ingiza matokeo halali ya timu zote mbili.");
      return;
    }

    const invalidOdds = scoreOdds.find((item) => {
      const odds = toNumber(item.odds);
      return odds == null || odds < 1.01;
    });

    if (invalidOdds) {
      setError(`Odds si sahihi kwa score ${invalidOdds.score}.`);
      return;
    }

    setSaving(true);

    try {
      await updateDoc(doc(db, COLLECTION, selectedId), {
        score: { home, away },
        correctScoreOdds: scoreOdds.map((item) => ({
          score: item.score,
          odds: Number(item.odds),
        })),
        status: "finished",
        updatedAt: serverTimestamp(),
        resultUpdatedBy: getAdminIdentity().uid,
        resultSavedAt: serverTimestamp(),
      });

      setSuccess("Matokeo na Correct Score zimehifadhiwa.");
      setSelectedId("");
      setScoreHome("");
      setScoreAway("");
      setScoreOdds(makeScoreOdds());
      await loadMatches();
    } catch (err) {
      setError(err?.message || "Imeshindikana kuhifadhi matokeo.");
    } finally {
      setSaving(false);
    }
  }

  const selectedMatch = matches.find(
    (match) => match.id === selectedId
  );

  return (
    <main className="ih-page">
      <header className="ih-header">
        <div>
          <span className="ih-eyebrow">ADMIN / SPORTS</span>
          <h1>Admin Add Ice Hockey</h1>
          <p>Ongeza mechi, odds za 1X2 na matokeo.</p>
        </div>
        <div className="ih-count">
          <strong>{matches.length}</strong>
          <span>Mechi</span>
        </div>
      </header>

      {error && <div className="ih-alert ih-error">{error}</div>}
      {success && <div className="ih-alert ih-success">{success}</div>}

      <section className="ih-panel">
        <h2>Paste Mechi kutoka Bookmaker</h2>
        <p className="ih-muted">
          Bandika maandishi yenye ligi, timu mbili, odds tatu za 1X2,
          na tarehe/muda. Parser inajaribu kutambua format ya mfano
          uliotuma.
        </p>

        <form onSubmit={importBulk}>
          <label className="ih-label">
            Maandishi ya bookmaker
            <textarea
              className="ih-textarea"
              rows={14}
              value={bulkText}
              onChange={(event) => setBulkText(event.target.value)}
              placeholder={`Russia - KHL
Amur Khabarovsk
HC Lada Togliatti
1.703.753.70
Today 12:00`}
              required
            />
          </label>

          <div className="ih-actions">
            <button
              className="ih-primary"
              type="submit"
              disabled={bulkSaving || preview.length === 0}
            >
              {bulkSaving
                ? "Inaingiza..."
                : `Import Mechi ${preview.length}`}
            </button>
            <button
              className="ih-secondary"
              type="button"
              onClick={() => setBulkText("")}
              disabled={bulkSaving}
            >
              Futa Maandishi
            </button>
          </div>
        </form>

        <div className="ih-preview">
          <h3>Preview ({preview.length})</h3>
          {preview.length === 0 ? (
            <p className="ih-empty">
              Bandika data ili kuona mechi zitakazotambuliwa.
            </p>
          ) : (
            <div className="ih-list">
              {preview.map((match, index) => (
                <article
                  className="ih-match"
                  key={`${match.homeTeam}-${match.awayTeam}-${index}`}
                >
                  <div className="ih-meta">
                    {match.country} · {match.league}
                  </div>
                  <div className="ih-teams">
                    <strong>{match.homeTeam}</strong>
                    <span>VS</span>
                    <strong>{match.awayTeam}</strong>
                  </div>
                  <p className="ih-muted">
                    {match.date} · {match.time}
                  </p>
                  <div className="ih-odds-row">
                    <span>1: {match.homeOdds}</span>
                    <span>X: {match.drawOdds}</span>
                    <span>2: {match.awayOdds}</span>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="ih-panel">
        <h2>Ongeza Mechi Moja</h2>

        <form className="ih-form" onSubmit={addMatch}>
          <label>
            Nchi
            <input
              name="country"
              value={form.country}
              onChange={handleFormChange}
              required
            />
          </label>

          <label>
            Ligi
            <input
              name="league"
              value={form.league}
              onChange={handleFormChange}
              placeholder="Mfano: KHL"
              required
            />
          </label>

          <label>
            Timu ya nyumbani
            <input
              name="homeTeam"
              value={form.homeTeam}
              onChange={handleFormChange}
              required
            />
          </label>

          <label>
            Timu ya ugenini
            <input
              name="awayTeam"
              value={form.awayTeam}
              onChange={handleFormChange}
              required
            />
          </label>

          <label>
            Tarehe
            <input
              type="date"
              name="date"
              value={form.date}
              onChange={handleFormChange}
              required
            />
          </label>

          <label>
            Muda (EAT)
            <input
              type="time"
              name="time"
              value={form.time}
              onChange={handleFormChange}
              required
            />
          </label>

          <label>
            Home odds (1)
            <input
              type="number"
              name="homeOdds"
              min="1.01"
              step="0.01"
              value={form.homeOdds}
              onChange={handleFormChange}
              required
            />
          </label>

          <label>
            Draw odds (X)
            <input
              type="number"
              name="drawOdds"
              min="1.01"
              step="0.01"
              value={form.drawOdds}
              onChange={handleFormChange}
              required
            />
          </label>

          <label>
            Away odds (2)
            <input
              type="number"
              name="awayOdds"
              min="1.01"
              step="0.01"
              value={form.awayOdds}
              onChange={handleFormChange}
              required
            />
          </label>

          <div className="ih-actions ih-full">
            <button className="ih-primary" type="submit" disabled={saving}>
              {saving ? "Inahifadhi..." : "Hifadhi Mechi"}
            </button>
            <button
              className="ih-secondary"
              type="button"
              onClick={() => setForm(EMPTY_FORM)}
            >
              Futa Form
            </button>
          </div>
        </form>
      </section>

      <section className="ih-panel" id="ih-results-editor">
        <h2>Matokeo na Correct Score</h2>

        {selectedMatch ? (
          <div className="ih-selected">
            <span>Mechi iliyochaguliwa</span>
            <strong>
              {selectedMatch.homeTeam} VS {selectedMatch.awayTeam}
            </strong>
          </div>
        ) : (
          <p className="ih-muted">
            Chagua mechi kwenye orodha ili kuingiza matokeo au kurekebisha
            Correct Score odds.
          </p>
        )}

        <div className="ih-score-form">
          <label>
            Home goals
            <input
              type="number"
              min="0"
              step="1"
              value={scoreHome}
              onChange={(event) => setScoreHome(event.target.value)}
              disabled={!selectedId || saving}
            />
          </label>
          <span>—</span>
          <label>
            Away goals
            <input
              type="number"
              min="0"
              step="1"
              value={scoreAway}
              onChange={(event) => setScoreAway(event.target.value)}
              disabled={!selectedId || saving}
            />
          </label>
        </div>

        <div className="ih-correct-score">
          <div className="ih-score-heading">
            <div>
              <h3>Correct Score Odds</h3>
              <p>Matokeo ya mfano baada ya dakika 60.</p>
            </div>
            <strong>{filteredScoreOdds.length} scores</strong>
          </div>

          <input
            className="ih-search"
            value={scoreSearch}
            onChange={(event) => setScoreSearch(event.target.value)}
            placeholder="Tafuta score, mfano 3-2..."
            disabled={saving}
          />

          <div className="ih-score-grid">
            {filteredScoreOdds.map((item) => (
              <label className="ih-score-option" key={item.score}>
                <span>{item.score}</span>
                <input
                  type="number"
                  min="1.01"
                  step="0.01"
                  value={item.odds}
                  onChange={(event) =>
                    setScoreOdds((previous) =>
                      previous.map((entry) =>
                        entry.score === item.score
                          ? { ...entry, odds: event.target.value }
                          : entry
                      )
                    )
                  }
                  disabled={!selectedId || saving}
                />
              </label>
            ))}
          </div>

          <p className="ih-muted">
            Correct Score odds ni mifano tu. Hakikisha unatumia odds
            ulizokusudia kabla ya kuweka soko wazi kwa wateja.
          </p>
        </div>

        <div className="ih-actions">
          <button
            className="ih-primary"
            type="button"
            onClick={saveResults}
            disabled={!selectedId || saving}
          >
            {saving ? "Inahifadhi..." : "Hifadhi Matokeo na Odds"}
          </button>
          <button
            className="ih-secondary"
            type="button"
            onClick={() => {
              setSelectedId("");
              setScoreHome("");
              setScoreAway("");
              setScoreOdds(makeScoreOdds());
            }}
          >
            Futa Selection
          </button>
        </div>
      </section>

      <section className="ih-panel">
        <div className="ih-list-heading">
          <div>
            <h2>Mechi Zilizohifadhiwa</h2>
            <p className="ih-muted">
              Chagua mechi ili kuhariri matokeo na Correct Score.
            </p>
          </div>
          <button
            className="ih-secondary"
            type="button"
            onClick={loadMatches}
            disabled={loading}
          >
            {loading ? "Inapakia..." : "Refresh"}
          </button>
        </div>

        <input
          className="ih-search"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Tafuta timu au ligi..."
        />

        {loading ? (
          <p className="ih-empty">Inapakia...</p>
        ) : filteredMatches.length === 0 ? (
          <p className="ih-empty">Hakuna mechi zilizopatikana.</p>
        ) : (
          <div className="ih-list">
            {filteredMatches.map((match) => (
              <article className="ih-match" key={match.id}>
                <div className="ih-meta">
                  {match.country} · {match.league}
                  <span>{match.status || "upcoming"}</span>
                </div>

                <div className="ih-teams">
                  <div>
                    <strong>{match.homeTeam}</strong>
                    <small>{match.score?.home ?? "—"}</small>
                  </div>
                  <span>VS</span>
                  <div>
                    <strong>{match.awayTeam}</strong>
                    <small>{match.score?.away ?? "—"}</small>
                  </div>
                </div>

                <div className="ih-odds-row">
                  <span>1: {match.odds?.home ?? "—"}</span>
                  <span>X: {match.odds?.draw ?? "—"}</span>
                  <span>2: {match.odds?.away ?? "—"}</span>
                </div>

                <p className="ih-muted">
                  {match.date || "—"} · {match.time || "—"}
                </p>

                <button
                  className={
                    selectedId === match.id
                      ? "ih-secondary"
                      : "ih-primary"
                  }
                  type="button"
                  onClick={() => selectMatch(match)}
                  disabled={saving}
                >
                  {selectedId === match.id
                    ? "Imechaguliwa"
                    : "Ingiza / Hariri Matokeo"}
                </button>
              </article>
            ))}
          </div>
        )}
      </section>

      <p className="ih-footnote">
        Firestore collection: <code>icehockeymatches</code>
      </p>
    </main>
  );
}
